// This file was automatically generated from uiwidget.TagInput.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.TagInput');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.docTags');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TagInput.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="taginput-container el8TextareaWrap ebs-form-control"><span class="taginput-tag-section el8InlineBlock"><ul class="taginput-tag-list"></ul></span><span class="taginput-input-section el8InlineBlock w100"><input class="taginput-input w100" name="tags" /></span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TagInput.tagList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var tagList1046 = opt_data.tags;
  var tagListLen1046 = tagList1046.length;
  for (var tagIndex1046 = 0; tagIndex1046 < tagListLen1046; tagIndex1046++) {
    var tagData1046 = tagList1046[tagIndex1046];
    el8.template.uiwidget.TagInput.tag({tag: tagData1046}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.TagInput.tag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li data-id="', soy.$$escapeHtml(opt_data.tag.id), '" class="taginput-tag-item el8DocTag el8InlineBlock mr10 mb5 el8Relative" tabindex="-1">');
  el8.template.appshared.docTags.docTag({tag: opt_data.tag, removeButton: true}, output);
  output.append('</li>');
  if (!opt_sb) return output.toString();
};
